import { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';

import { ChartType } from '../../types/chartTypes';
import CrystalsContent from '../charts/Crystals';
import SoulMatrixContent from '../charts/SoulMatrix';
import { ControlPanel } from '../ControlPanel/ControlPanel';
import { Section } from '../Section/Section';
import { useAuth } from '../../contexts/AuthContext';

import styles from './PersonalAccount.module.scss';

const contentVariants = {
  initial: { opacity: 0 },
  animate: { opacity: 1 },
  exit: { opacity: 0 },
};

export function PersonalAccount() {
  const { activeProfile } = useAuth();
  const [activeChart, setActiveChart] = useState<ChartType>('soulMatrixChart');

  const handleChartChange = (chartKey: ChartType) => {
    setActiveChart(chartKey);
  };

  if (!activeProfile) return null;

  const renderActiveChart = () => {
    switch (activeChart) {
      case 'soulMatrixChart':
        return <SoulMatrixContent activeProfile={activeProfile} />;
      // TODO: TMP disable pythagorean square chart!!!
      // case 'pythagoreanSquareChart':
      //   return <PythagoreanSquareContent activeProfile={activeProfile} />;

      case 'crystalsChart':
        return <CrystalsContent activeProfile={activeProfile} />;
    }
  };

  return (
    <Section className={styles.personalAccount}>
      <div className="container">
        <ControlPanel activeProfile={activeProfile} activeChart={activeChart} handleChartChange={handleChartChange} />
        <div className={styles.contentWrapper}>
          {/* @ts-expect-error framer-motion types incompatible with @types/react 18 */}
          <AnimatePresence mode="wait">
            <motion.div
              key={activeChart}
              style={{ height: '100%' }}
              variants={contentVariants}
              initial="initial"
              animate="animate"
              exit="exit"
              transition={{ duration: 0.2 }}
            >
              {renderActiveChart()}
            </motion.div>
          </AnimatePresence>
        </div>
      </div>
    </Section>
  );
}
